import { StyleSheet } from 'react-native';

import { createStyles } from '@/hooks';
import { colors } from '@/theme/colors';

export const useStyles = createStyles(({ scale }) => ({
  divider: {
    height: StyleSheet.hairlineWidth,
    backgroundColor: colors['10'],
  },
  sectionTitle: {
    color: colors.Blue,
    textTransform: 'uppercase',
  },
  sectionDivider: {
    height: StyleSheet.hairlineWidth,
    backgroundColor: colors['10'],
    marginHorizontal: scale({ phone: -18, tablet: -24 }),
    marginTop: scale(12),
    marginBottom: scale(8),
  },
  card: {
    backgroundColor: colors['0'],
    borderRadius: scale(2),
    shadowColor: '#000',
    shadowOpacity: 0.12,
    shadowRadius: 4,
    shadowOffset: { width: 0, height: 2 },
    elevation: 2,
  },
  cardBodyRow: {
    width: '100%',
    borderRadius: scale(2),
  },
  cardHeaderRow: {
    borderTopRightRadius: scale(2),
  },
  cardAccent: {
    width: scale(9),
  },
  levelTitle: {
    textTransform: 'uppercase',
  },
  subText: {
    color: colors['6'],
  },
  rowDivider: {
    height: StyleSheet.hairlineWidth,
    backgroundColor: colors['3'],
    marginLeft: scale(9),
  },
  collapsibleContainer: {
    width: '100%',
  },
  badgeTrigger: {
    paddingLeft: scale(9),
    paddingRight: scale(16),
    paddingVertical: scale(12),
  },
  badgeTriggerInner: {
    width: '100%',
  },
  badgeName: {
    color: colors['10'],
    flex: 1,
    marginRight: scale(10),
  },
  badgeContent: {
    paddingLeft: scale(9),
    paddingRight: scale(16),
    paddingBottom: scale(8),
  },
  badgeContentHeader: {
    paddingTop: scale(4),
    paddingBottom: scale(10),
  },
  badgeContentTitle: {
    textTransform: 'capitalize',
  },
  badgeContentStatus: {},
  checkpointRow: {
    width: '100%',
  },
  checkpointName: {
    color: colors['6'],
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    backgroundColor: 'white',
    paddingRight: scale(6),
    justifyContent: 'center',
    zIndex: 9,
  },
  checkpointLeaderText: {
    flex: 1,
    marginHorizontal: scale(8),
    color: colors['4'],
  },
  checkpointStatus: {
    color: colors['6'],
    textAlign: 'right',
  },
  checkpointAttempt: {
    color: colors['6'],
    textAlign: 'right',
  },
  completedBadgeLabel: {
    color: colors.Success,
    textAlign: 'center',
  },
  completedBadgeSub: {
    color: colors['6'],
    textAlign: 'center',
  },
  detailsButton: {
    marginLeft: 'auto',
    marginRight: scale(4),
    flexDirection: 'row',
    alignItems: 'center',
    gap: scale(8),
    marginTop: scale(10),
  },
  detailsText: {
    color: colors.Blue,
    textTransform: 'uppercase',
  },
  detailsTextTablet: {
    fontSize: scale(11),
    fontWeight: '400',
  },
  detailsIcon: {
    transform: [{ rotate: '180deg' }],
  },
  wrapRow: {
    flexWrap: 'wrap',
  },
  checkpointStatusMask: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'white',
    paddingLeft: scale(6),
    justifyContent: 'center',
    zIndex: 9,
  },
}));
